import React from "react";
import { NavLink } from "react-router-dom";

import { visibleAreas } from "../areas";
import AccountChip from "./AccountChip";
import { AreaIcon, BrandMark } from "./icons";

/**
 * The permanent global Y-axis. Brand top, five areas, account bottom.
 *
 * SHELL.md: it answers "Where am I in Cipher?" and is stable everywhere —
 * "Rendered by `CipherShell.ynav(activeArea)` so it exists in exactly one
 * place." This is that one place.
 *
 * WHAT A NON-FOUNDER SEES, AND WHAT THAT DOES AND DOES NOT MEAN
 * ============================================================
 * `visibleAreas` filters by the operator's role, so a founder-only destination
 * is ABSENT rather than disabled — a disabled entry still tells you the thing
 * exists. That is navigation agreeing with the backend, which is R5's actual
 * requirement. It is not a gate: the server refuses these routes independently
 * and would still refuse them if this list were edited in a debugger.
 *
 * `NavLink` supplies `aria-current="page"` on the active entry, so the active
 * area is announced rather than only coloured.
 *
 * `onSignOut` is passed straight through to the account chip. The Y-axis does
 * not call it and does not know what it does — it is the shell's only route
 * from the session, held in V2Routes, down to the control at the foot of this
 * nav. See AccountChip.jsx for why it travels as a prop rather than a hook.
 */
export default function YNav({ user, onSignOut }) {
  const areas = visibleAreas(user);

  return (
    <nav className="ynav" aria-label="Cipher areas">
      <div className="brand">
        <span className="mark">
          <BrandMark />
        </span>
        <span className="name">Cipher</span>
      </div>

      <ul className="ynav-list">
        {areas.map((area) => (
          <li key={area.id}>
            <NavLink
              to={area.path}
              className={({ isActive }) => (isActive ? "nav on" : "nav")}
            >
              <AreaIcon name={area.icon} />
              <span>{area.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="spacer" />
      <AccountChip user={user} onSignOut={onSignOut} />
    </nav>
  );
}
